import React from 'react';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { WorkerCard } from '../../../../../../base/components/WorkerCard';
import { Button } from '../../../../../../base/components/Button';
import { vacancyActions } from '../../../redux/slices/vacancySlice';

export const RecommendedWorkers = () => {
    const { recommendations } = useAppSelector((state) => state.vacancy);
    const dispatch = useAppDispatch();

    if (!recommendations || !recommendations.workers || !recommendations.workers.count) {
        return null;
    }

    const onFavoritesClick = (id: number, newValue: boolean) => dispatch(vacancyActions.recommendedWorkerFavoritesToggleRequest(id, newValue));

    return (
        <div className='vacancy-confirmation-page__section'>
            <div className='vacancy-confirmation-page__section-title-wrap'>
                <h3 className='vacancy-confirmation-page__section-title'>{__t('Рекомендованные работники')}</h3>
                <a href={recommendations.workers.url} className='count-link'>
                    <span className='count-link__text'>{__t('Все анкеты')}</span>
                    <span className='count-link__count'>{recommendations.workers.count}</span>
                    <span className='count-link__icon'>
                        <Icon icon='arrow-right' color='danger' size='14px' />
                    </span>
                </a>
            </div>

            <div className='cards-container'>
                {recommendations.workers.profiles.map((profile) => (
                    <React.Fragment key={profile.id}>
                        <WorkerCard {...profile} onFavoritesClick={() => onFavoritesClick(profile.id, !profile.isFavorite)} />
                    </React.Fragment>
                ))}
            </div>

            <Button
                type='secondary'
                routerLinkPath={recommendations.workers.url}
                className='vacancy-confirmation-page__mobile-button'
            >
                <span className='count-link__text'>{__t('Все анкеты')}</span>
                <span className='count-link__count'>{recommendations.workers.count}</span>
            </Button>
        </div>
    );
};
